import { Icon, Menu } from 'antd';
import React from 'react';
import TiledTitleList from '../Titles/TiledTitleList';
import { useShelves } from './containers/ShelvesDataStore';
import ShelfType from './ShelfType';

export default function ShelvesMenu() {
	const shelvesDataStore = useShelves();
	const { isLoading, shelves, selectedMenuOption } = shelvesDataStore.state;

	const renderShelves = () => {
		const filteredShelves = shelves.filter(
			sh => sh.shelf === selectedMenuOption,
		);
		var shelfSkus = shelves.map(item => item.sku);
		return (
			<TiledTitleList
				skus={shelfSkus}
				isLoading={isLoading}
				titles={filteredShelves}
			/>
		);
	};

	const renderMenuItem = shelfType => {
		const count = shelves.filter(sh => sh.shelf === shelfType.key).length;
		return (
			count > 0 && (
				<Menu.Item key={shelfType.key}>
					<Icon type={shelfType.key} />
					<b>{count}</b> {shelfType.text}
				</Menu.Item>
			)
		);
	};

	const handleClick = e => {
		shelvesDataStore.setSelectedMenuOption(e.key);
	};

	return (
		<>
			<div>
				<Menu
					onClick={handleClick}
					selectedKeys={[selectedMenuOption]}
					mode="horizontal">
					{Object.keys(ShelfType).map(shelf => {
						return (
							ShelfType[shelf].doRenderInList &&
							renderMenuItem(ShelfType[shelf])
						);
					})}
				</Menu>
			</div>
			{renderShelves()}
		</>
	);
}
